import * as types from "../types";

const initialState = {
  analyticsData: [],
  totalRecords: null,
  loading: false,
  error: null,
};

export const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ANALYTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        analyticsData: action.payload?.results || [],
        totalRecords: action.payload?.count || 0,
      };

    case types.ANALYTICS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
